// extracted by mini-css-extract-plugin
module.exports = {"main-container":"main-container-2-xqn24EiTRY9x39uzGYwy","mainContainer":"main-container-2-xqn24EiTRY9x39uzGYwy"};